import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import type { ReactNode } from 'react';
import ProgressSkeleton from 'components/layout/ProgressSkeleton';

const AuthRequired = ({ children }: { children: ReactNode; }) => {
  const location = useLocation();
  const { route } = useAuthenticator((context) => [context.route]);


  if (route === 'idle') {
    return <ProgressSkeleton />;
  }

  if (route !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};
export default AuthRequired;
